export const UTILS_VERSION = '<UTILS_VERSION>';
